export const topo_menu = [
  {
    title: '<i class="fa fa-sign-in" aria-hidden="true"></i> ASSOCIE-SE',
    url: "https://amib.org.br/anuidades/",
    menu_order: 1,
    style: {
      "font-size": "10px",
      "font-weight": "700",
      "text-transform": "uppercase",
      fill: "#FFFFFF",
      color: "#FFFFFF",
      "background-color": "#1A3755",
      "border-radius": "25px",
      padding: "0.5rem 1rem",
    },
  },
  {
    title: '<i class="fa fa-barcode" aria-hidden="true"></i> RENOVE ANUIDADE',
    url: "/offers-unique/1",
    menu_order: 2,
    style: {
      "font-size": "10px",
      "font-weight": "700",
      "text-transform": "uppercase",
      fill: "#FFFFFF",
      color: "#FFFFFF",
      "background-color": "#0c477f",
      "border-radius": "25px",
      padding: "0.5rem 1rem",
    },
  },
  {
    title: "CRITICAL CARE SCIENCE JOURNAL",
    url: "https://amib.org.br/ccs/",
    menu_order: 3,
    style: {
      "font-size": "10px",
      "font-weight": "700",
      "text-transform": "uppercase",
      fill: "#FFFFFF",
      color: "#FFFFFF",
      "background-color": "#FF0000",
      "border-radius": "25px",
      padding: "0.5rem 1rem",
    },
  },
];
